(function() {
    angular.module("app").controller("NoticeCreateEditModalController", NoticeCreateEditModalController)

    NoticeCreateEditModalController.$inject = [
        "$scope",
        "$uibModal",
        "$uibModalInstance",
        "existingNotice",
        "saveNotice"
    ]

    function NoticeCreateEditModalController(
        $scope,
        $uibModal,
        $uibModalInstance,
        existingNotice,
        saveNotice
    ){
        "use strict"

        $scope.isCreate          = existingNotice === undefined
        $scope.notice            = {}
        $scope.selectedDate      = new Date()
        $scope.datePickerOpen    = false
        $scope.showConfirmCancel = false
        $scope.format            = "MM/dd/yyyy"

        $scope.datePickerOptions = {
            formatYear:  "yy",
            startingDay: 1,
            showWeeks:   false
        }

        if (existingNotice) {
            $scope.notice = {
                id:         existingNotice.id,
                title:      existingNotice.title,
                content:    existingNotice.content,
                publish_on: existingNotice.publish_on
            }
           $scope.selectedDate = new Date($scope.notice.publish_on)
        }

        $scope.openDatePicker = function() {
            $scope.datePickerOpen = true
        }

        $scope.save = () => {

            $scope.submitted = true

            if ($scope.noticeForm.$valid) {
                $scope.notice.publish_on = $scope.selectedDate
                $uibModalInstance.close(saveNotice($scope.notice))
            }
        }

        $scope.preview = () => {

            $scope.submitted = true

            if ($scope.noticeForm.$valid) {

                $scope.submitted = false
                $scope.notice.publish_on = $scope.selectedDate

                $uibModal.open({
                    templateUrl: "app/modals/notice-modal.view.html",
                    controller: "NoticeModalController",
                    backdrop: "static",
                    keyword: false,
                    windowClass: "noticeModal",
                    resolve: {
                        previewNotice: () => {
                            return $scope.notice
                        },
                        emailNotice: () => {
                            return undefined
                        },
                        markNoticeAsRead: () => {
                            return undefined
                        }
                    }

                })

            }
        }

        $scope.cancel = function(force) {

            if (!force) {

                let requireConfirm = false

                if ($scope.notice.title !== undefined) {

                    const title = $scope.notice.title.trim()

                    if ($scope.isCreate) {
                        requireConfirm = title.length > 0
                    } else {
                        requireConfirm = title !== existingNotice.title
                    }
                }

                if (!requireConfirm && $scope.notice.content !== undefined) {

                    const content = $scope.notice.content.trim()

                    if ($scope.isCreate) {
                        requireConfirm = content.length > 0
                    } else {
                        requireConfirm = content !== existingNotice.content
                    }
                }

                if (!requireConfirm && !$scope.isCreate) {
                    requireConfirm = moment($scope.selectedDate).format("MMMM Do, YYYY") !== moment(existingNotice.publish_on).format("MMMM Do, YYYY")
                }

                if (requireConfirm) {
                    $scope.showConfirmCancel = true
                    return
                }
            }

            $uibModalInstance.dismiss("cancel")

        }

        $scope.resume = () => {
            $scope.showConfirmCancel = false
        }
    }
})()
